var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"dovetail-app"},[_c('dt-progressbar'),_c('sidebar'),_c('snackbar'),_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),_c('dialogbox')],1)}
var staticRenderFns = []

export { render, staticRenderFns }